// Wire validation only. Accounting and availability decisions belong to each server domain.
export function normalizeQuotaOverview(value) {
  const statuses = ['READY', 'EXHAUSTED', 'BLOCKED', 'DISABLED', 'UNAVAILABLE']
  const result = { sections: [] }
  for (const [key, title] of [['ai', 'AI 对话'], ['speech', '语音识别']]) {
    const entry = value && value[key]
    const p = entry && entry.presentation
    const hasBalance = p && p.balance && typeof p.balance.value === 'string' && p.balance.unit === '%' &&
      Number.isFinite(p.balance.percent) && p.balance.percent >= 0 && p.balance.percent <= 100
    const hasPeriod = p && p.period && Array.isArray(p.period.rows) && p.period.rows.length === 2 &&
      p.period.rows.every(row => typeof row.label === 'string' && typeof row.value === 'string' && typeof row.at === 'string')
    const valid = entry && statuses.includes(entry.status) && typeof entry.message === 'string' &&
      ((!p && ['DISABLED', 'UNAVAILABLE'].includes(entry.status)) || (hasBalance && hasPeriod))
    result.sections.push(valid ? { ...entry, title, key } : { key, title, status: 'UNAVAILABLE', message: '额度暂不可用，请刷新重试', presentation: null })
  }
  return result
}
